export const menuLocations = {
  HEADER: 'MENU_1',
  FOOTER_MENU: 'FOOTER_MENU',
};

export const templateNames = {
  FLEXIBLEMODULES: 'Flexible Modules',
  RECIPESGALLERY: 'Recipes Gallery',
  PRODUCTSGALLERY: 'Products Gallery',
  ARTICLESGALLERY: 'Articles Gallery',
  FAQ: 'FAQ',
  SITEMAP: 'Site Map',
};

export const homePageUri = '/';

export const slugs = {
  RECIPES: '/recipes/',
  PRODUCTS: '/products/',
  ARTICLES: '/articles/',
};

// SEO Constants, set FOLLOW or INDEX to override noindex/nofollow sitewide.
export const seoSettings = {
  FOLLOW: 'follow',
  NOFOLLOW: 'nofollow',
  INDEX: 'index',
  NOINDEX: 'noindex',
  MAXIMAGEPREVIEW: 'large',
  MAXSNIPPET: '-1',
  MAXVIDEOPREVIEW: '-1',
};

// Used in SEO schema author field and parentOrganization
export const organization = 'General Mills';

export const defaultAuthorType = 'Person';
